/**
 * A season recap's own line under its title on the splash card (RecapSummary.line, the `recaps`
 * row's `line`, migrations/0061_recap_line.sql). Owner, 2026-11-03: "The recap text is wrong on the
 * splash screen": the line was written into both clients for September's recap, and each month's
 * recap is different, so it belongs to the recap. Read by the server's summary and Hall, the Hall's
 * saved months and both clients' cards.
 */

/** The line as the card draws it: the text trimmed, or null for none (absent, NULL, not text, only blanks). */
export function recapLine(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const line = raw.trim();
  return line ? line : null;
}
